<template>
    <div class="co-papel-signatario">
        <v-select
            v-model="value.papelId"
            v-validate="validarCampo()"
            :class="campoRequerido ? 'required-field' : ''"
            :error-messages="coletarErros(errors)"
            :items="filtrarItems()"
            item-disabled="inativo"
            item-value="id"
            item-text="nome"
            label="Papel"
            name="Papel assinatura"
            placeholder="Selecione"
            persistent-placeholder
            :rules="[(v) => !!v || 'Informe o campo obrigatório']">
        </v-select>

        <div v-if="descricao" class="hint-checkbox">
            {{ descricaoCampo }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'PapelSignatario',
    props: {
        value: {
            required: true
        },
        campoRequerido: {
            type: Boolean,
            default: false
        },
        descricao: {
            type: Boolean
        },
        papeis: {
            required: true,
            type: Array,
            default: () => []
        },
        formScope: {
            type: String,
            required: false,
            default: null
        }
    },
    data: () => ({
        papeisSelecao: []
    }),
    computed: {
        descricaoCampo() {
            return `Função que o ${this.$tc("pt_br.signatario").toLowerCase()} desempenhará no momento da assinatura`
        },
    },
    methods: {
        coletarErros(e) {
            if (this.formScope !== null) {
                return e.collect('Papel assinatura', this.formScope)
            }

            return e.collect('Papel assinatura')
        },
        filtrarItems() {
            return this.papeis.filter(papel => !papel.inativo || this.value.papelId === papel.id)
        },
        validarCampo() {
            return this.campoRequerido ? 'required' : ''
        }
    }
}
</script>
